import React, { useEffect } from 'react';
import { connect } from 'react-redux';

import { getSucursalesAction } from '../../redux/actions/sucursal.action';

import SucursalList from './SucursalList';
import SucursalItem from './SucursalItem';
import SucursalFilter from './SucursalFilter';
import SucursalNew from './SucursalNew';
import SucursalPromotion from './SucursalPromotion';

const Sucursal = ({
  openModal,
  openModalEdit,
  openModalPromotion,
  getSucursalesAction,
}) => {
  useEffect(() => {
    getSucursalesAction({});
  }, []);

  return (
    <div className="op-component">
      <SucursalList />
      <SucursalFilter />
      {openModal && <SucursalNew />}
      {openModalEdit && <SucursalItem />}
      {openModalPromotion && <SucursalPromotion />}
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    openModal: state.sucursal.openModal,
    openModalEdit: state.sucursal.openModalEdit,
    openModalPromotion: state.sucursal.openModalPromotion,
  };
};

export default connect(mapStateToProps, {
  getSucursalesAction,
})(Sucursal);
